// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h97kb_QNYoIemYvaUaMc{flex-direction:column;padding-top:3px;display:flex}.TX6hQmfUIsBjrxYcJv2M{align-items:center;gap:8px;margin-top:-21px;padding:0 20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `h97kb_QNYoIemYvaUaMc`,
	"starsWrap": `TX6hQmfUIsBjrxYcJv2M`
};
export default ___CSS_LOADER_EXPORT___;
